const Languages = {
  en: "en",
  zh: "zh",
};

export default Languages;
